import React from 'react';
import { Nav, NavItem, } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const tabs = [
  { name: 'combiningRequests', label: '加工依頼', path: 'combiningRequests' },
  { name: 'combiningTemplates', label: '加工組マスタ', path: 'combiningTemplates' },
];

export default function CombiningsTabs(props) {
  const { activeTab, } = props;

  return (
    <Nav tabs className="mb-3">
      {
        tabs.map(({ label, name, path }) => {
          return (
            <NavItem key={name}>
              <Link className={classnames('nav-link cursor-pointer', { active: activeTab === name })} to={`/${path}`}>
                {label}
              </Link>
            </NavItem>
          )
        })
      }
    </Nav>
  );
};
